export class WinPresentationEvents {
    public static readonly INITIAL_ANIMATION_STARTED: symbol = Symbol('INITIAL_ANIMATION_STARTED');
    public static readonly PAY_ANIMATION_STARTED: symbol = Symbol('PAY_ANIMATION_STARTED');
    public static readonly INITIAL_ANIMATION_FINISHED: symbol = Symbol('INITIAL_ANIMATION_FINISHED');
    public static readonly INITIAL_ANIMATION_SKIPPED: symbol = Symbol('INITIAL_ANIMATION_SKIPPED');
    public static readonly INITIAL_ANIMATION_FREESPINS_FINISHED: symbol = Symbol('INITIAL_ANIMATION_FREESPINS_FINISHED');
    public static readonly ALL_PAY_ANIMATIONS_FINISHED: symbol = Symbol('__ALL_PAY_ANIMATIONS_FINISHED__');
    public static readonly PAUSED: symbol = Symbol('__PAUSED__');
    // Emit after WinMeter and all pays animations finished
    public static readonly PAY_ANIMATIONS_AND_WIN_METER_FINISHED: symbol = Symbol('PAY_ANIMATIONS_AND_WIN_METER_FINISHED');
}
